import { fullSingleLineAddress, HasAddress, IContact, IPlacement } from "@sp-crm/core";
import {
    EntityDetails,
    hasEntityDetails,
    labeledContactPhones,
    present,
} from "components/details-page-v-next/entity-contact-details";

type ClientSource = Pick<
    IPlacement,
    "name" | "cellPhone" | "phone" | "email" | "emailOptOut"
> &
    HasAddress;

type BestContactSource = Pick<
    IContact,
    "name" | "cellPhone" | "phone1" | "email1" | "email1OptOut"
> &
    HasAddress;

const emptyDetails = (): EntityDetails => ({
    classification: null,
    classificationLabel: "Relationship",
    phones: [],
    fax: null,
    email: null,
    emailOptOut: false,
    address: null,
    website: null,
    organization: null,
});

export const clientContactDetails = (client: ClientSource): EntityDetails => ({
    classification: null,
    classificationLabel: "Relationship",
    phones: labeledContactPhones({ cell: client.cellPhone, alternate: client.phone }),
    fax: null,
    email: present(client.email),
    emailOptOut: client.emailOptOut,
    address: present(fullSingleLineAddress(client)),
    website: null,
    organization: null,
});

export const clientBestContactDetails = (
    bestContact: BestContactSource | null,
): EntityDetails => {
    if (!bestContact) {
        return emptyDetails();
    }

    return {
        classification: null,
        classificationLabel: "Relationship",
        phones: labeledContactPhones({
            cell: bestContact.cellPhone,
            alternate: bestContact.phone1,
        }),
        fax: null,
        email: present(bestContact.email1),
        emailOptOut: bestContact.email1OptOut,
        address: present(fullSingleLineAddress(bestContact)),
        website: null,
        organization: null,
    };
};

export interface ClientDetailsSource {
    client: ClientSource;
    bestContact: BestContactSource | null;
}

export const hasClientDetails = (source: ClientDetailsSource): boolean =>
    !!present(source.client.name) ||
    !!present(source.bestContact?.name) ||
    hasEntityDetails(clientContactDetails(source.client)) ||
    hasEntityDetails(clientBestContactDetails(source.bestContact));
